import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Text,
  Image,
  MenuList,
  MenuItem,
  MenuButton,
  Menu,
  useBreakpointValue,
  Wrap,
  WrapItem,
  Drawer,
  DrawerContent,
  DrawerBody,
  DrawerOverlay,
} from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { CAR_INFO, carVersionI18n } from "lib/cars";
import GCPImage from "components/GCPImage";
import { useMemo, useState } from "react";
import { CheckIcon, ChevronDownIcon, CloseIcon } from "@chakra-ui/icons";
import appStore from "store";
import { useRouter } from "next/router";
import stationStore from "store/station";
import SortContentDrawer from "./SortContentDrawer";
import StationDetailModal from "./StationDetailModal";

const ListContent = ({
  onClose,
  firstCarData,
  isOpenSort,
  setIsOpenSort,
  selectedCarData,
  setSelectedLocation,
  setIsOpenStationDetail,
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const isLgUp = useBreakpointValue({ base: false, lg: true });
  const { priceListSortBy, filteredStationZones } = stationStore;
  const { configs } = appStore;

  let title = `${firstCarData?.brand} ${firstCarData?.model_name}`;
  let subTitle = carVersionI18n(firstCarData?.version, t) || "";

  const goCarInfo = (selectedCarData, zoneId, provider) => {
    appStore.selectedZoneId = zoneId;
    appStore.selectedReturnZoneId = zoneId;
    appStore.availableCarIds = selectedCarData.map((car) => car.id);
    appStore.selectedCarIds = selectedCarData.map((car) => car.id);

    const thisZone = filteredStationZones.find(
      (zone) => zone.id.toString() === provider.split("_")[1]
    );

    const selectedLocationId = selectedCarData.map(
      (car) => car.service_location.id
    );

    const _zoneDetail = {
      ...thisZone,
      supportConfigs: configs.filter((config) =>
        selectedLocationId.includes(config.location_id)
      ),
    };

    appStore.zoneDetail = _zoneDetail;
    router.push({
      pathname: "/station/carInfo",
      query: {
        ...router.query,
      },
    });
  };

  return (
    <>
      {/* 關閉按鈕 */}
      <Flex
        px={{ base: "16px", lg: "32px" }}
        pt={{ base: "16px", lg: "32px" }}
        h={{ base: "64px", lg: "32px" }}
        justifyContent="flex-end"
      >
        <Flex
          mt={{ base: "0px", lg: "-16px" }}
          w="40px"
          h="40px"
          bg="#F3F4F9"
          borderRadius="20px"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={onClose}
        >
          <CloseIcon w="14px" h="14px" />
        </Flex>
      </Flex>

      {/* 車輛資訊 */}
      {firstCarData && (
        <Flex
          px={{ base: "16px", lg: "32px" }}
          pt={{ base: "0px", lg: "16px" }}
          w="100%"
          mb={{ base: "28px", lg: "24px" }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex w="100%" alignItems={{ base: "center", lg: "flex-start" }}>
            <Flex flexDir="column" alignItems="flex-start" w="100%">
              {/* 平台優選、立即確認 */}
              <Flex mb="16px" alignItems="center">
                {firstCarData.model_name === "Model 3" &&
                  firstCarData.version === null && (
                    <Text
                      mr="8px"
                      textStyle="notoH12"
                      fontWeight="bold"
                      color="white"
                      bg="#333333"
                      px="8px"
                      py="4px"
                      borderRadius="12px"
                    >
                      {t("Station_carList_first")}
                    </Text>
                  )}
                {firstCarData.owner_settings?.order_auto_cancel_type ===
                  "auto_confirm" && (
                  <Text
                    mr="8px"
                    textStyle="notoH12"
                    fontWeight="bold"
                    border="1px solid #333333"
                    color="#333333"
                    px="8px"
                    py="3px"
                    borderRadius="12px"
                  >
                    {t("Station_carList_check")}
                  </Text>
                )}
              </Flex>

              <Flex
                w="100%"
                alignItems={{ base: "center", lg: "flex-start" }}
                flexDir={{ base: "row", lg: "column" }}
                justifyContent="space-between"
              >
                <Box>
                  <Text textStyle="poppinsH20" color="#333333" mb="8px">
                    {title}
                  </Text>

                  <Text fontSize="14px" lineHeight="20px" color="#333333">
                    {subTitle}
                  </Text>

                  <Wrap
                    alignItems="center"
                    mt="8px"
                    spacingX="12px"
                    spacingY="8px"
                  >
                    {CAR_INFO.map((item) => {
                      const value =
                        item.key.split(".").length === 2
                          ? item.key === "note.transmission"
                            ? t(firstCarData.note.transmission)
                            : firstCarData[item.key.split(".")[0]][
                                item.key.split(".")[1]
                              ]
                          : item.key === "vehicle_size_name"
                            ? t(
                                `Station_filter_carType_${firstCarData.vehicle_size_name}`
                              )
                            : firstCarData[item.key];

                      return (
                        <WrapItem key={item.key}>
                          <Flex alignItems="center">
                            <GCPImage
                              src={item.icon}
                              alt="car"
                              w={{ base: "16px", lg: "24px" }}
                              mr="2px"
                            />
                            <Text
                              fontSize={{ base: "12px", lg: "14px" }}
                              lineHeight={{ base: "16px", lg: "20px" }}
                              color="#748598"
                              mr={{ base: "0px", lg: "12px" }}
                            >
                              {t(value)} {item.subKey && t(item.subKey)}
                            </Text>
                          </Flex>
                        </WrapItem>
                      );
                    })}
                  </Wrap>
                </Box>
                <GCPImage
                  display={{ base: "block", lg: "none" }}
                  src={firstCarData.image + "?v=2"}
                  alt="car"
                  h="56px"
                />
              </Flex>
            </Flex>
          </Flex>
          <GCPImage
            display={{ base: "none", lg: "block" }}
            src={firstCarData.image + "?v=2"}
            alt="car"
            w="200px"
          />
        </Flex>
      )}

      {/* 分隔線 */}
      <Flex w="100%" h="8px" bg="#F3F4F9" />

      <Box px={{ base: "16px", lg: "32px" }}>
        <Flex my="8px" justifyContent="flex-end">
          <Menu>
            <MenuButton onClick={() => setIsOpenSort(true)}>
              <Flex
                pl="12px"
                py="8px"
                pr="10px"
                borderRadius="8px"
                bg="#F3F4F9"
                align="center"
              >
                <Text mr="2px" textStyle="notoH14">
                  {t(priceListSortBy)}
                </Text>
                <ChevronDownIcon w="16px" h="16px" />
              </Flex>
            </MenuButton>

            <MenuList display={isLgUp ? "block" : "none"}>
              {["sortFromLow", "sortFromHigh"].map((item) => {
                return (
                  <MenuItem
                    value={item}
                    key={item}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    onClick={(e) => {
                      stationStore.priceListSortBy = item;
                    }}
                  >
                    <Text
                      textStyle="notoP14"
                      color={priceListSortBy === item ? "#0067D8" : "#333333"}
                    >
                      {t(item)}
                    </Text>

                    <CheckIcon
                      w="16px"
                      h="16px"
                      display={priceListSortBy === item ? "block" : "none"}
                      color={priceListSortBy === item ? "#0067D8" : "#333333"}
                    />
                  </MenuItem>
                );
              })}
            </MenuList>
          </Menu>
        </Flex>

        {selectedCarData &&
          Object.keys(selectedCarData)
            .sort((a, b) => {
              if (priceListSortBy === "sortFromLow") {
                return (
                  selectedCarData[a][0].price - selectedCarData[b][0].price
                );
              } else {
                return (
                  selectedCarData[b][0].price - selectedCarData[a][0].price
                );
              }
            })
            .map((provider) => {
              const providerFirstCar = selectedCarData[provider][0];

              const thisZone = filteredStationZones.find(
                (zone) => zone.id.toString() === provider.split("_")[1]
              );
              const distance = thisZone?.distance.toFixed(2);

              const isInsurance1 = providerFirstCar.policies.find(
                (policy) => policy.key === "乙式-車碰車"
              );
              const isInsurance2 = providerFirstCar.policies.find(
                (policy) => policy.key === "丙式-車輛碰撞"
              );

              const isInsurance3 = providerFirstCar.policies.find(
                (policy) => policy.key === "第三人責任險"
              );

              return (
                <Flex
                  p="16px"
                  flexDir={{ base: "column", lg: "row" }}
                  justify="space-between"
                  w="100%"
                  key={provider}
                  h={{ base: "auto", lg: "154px" }}
                  borderRadius="16px"
                  bg="#F3F4F9"
                  mb="16px"
                  cursor="pointer"
                  onClick={() =>
                    goCarInfo(selectedCarData[provider], thisZone.id, provider)
                  }
                >
                  {/* 地點資訊 */}
                  <Box
                    w="100%"
                    mr={{ base: "0px", lg: "16px" }}
                    mb={{ base: "16px", lg: "0px" }}
                  >
                    <Flex
                      mb="16px"
                      justify="space-between"
                      alignItems={{ base: "center", lg: "start" }}
                      w="100%"
                      onClick={(e) => {
                        e.stopPropagation();
                        let detail = {};

                        const thisZoneConfig = configs.find(
                          (config) => config.location_name === thisZone.level_3
                        );

                        if (thisZoneConfig) {
                          detail = {
                            logo: thisZoneConfig.logo_image_url,
                            name: thisZoneConfig.location_name,
                            address:
                              thisZoneConfig.address ||
                              `${thisZone.level_1}${thisZone.level_2}${thisZone.level_3}`,
                            worktime: `${thisZoneConfig.business_start_hour}-${thisZoneConfig.business_end_hour}`,
                            phone: thisZoneConfig.phone,
                          };
                        } else {
                          detail = {
                            name: thisZone.level_3,
                            address: `${thisZone.level_1}${thisZone.level_2}${thisZone.level_3}`,
                          };
                        }

                        setSelectedLocation(detail);
                        setIsOpenStationDetail(true);
                      }}
                    >
                      <Flex alignItems="center">
                        <Image
                          src={
                            providerFirstCar.owner_settings?.logo_image_url ||
                            ""
                          }
                          // alt="logo"
                          h={{ base: "20px", lg: "28px" }}
                        />

                        <Box w="1px" h="16px" bg="#28292B" mx="8px"></Box>

                        <Text
                          flex="1"
                          minW="0"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textStyle="notoH16"
                          color="#333333"
                        >
                          {thisZone?.level_3}
                        </Text>

                        <GCPImage
                          src="/images/icons/chevronRight.png"
                          alt="logo"
                          w="24px"
                          h="24px"
                        />
                      </Flex>

                      <Text
                        whiteSpace="nowrap"
                        textStyle="notoP14"
                        color="#748598"
                      >
                        {t("distance")}{" "}
                        {distance < 1 ? distance * 1000 : distance}{" "}
                        {distance < 1 ? "m" : "km"}
                      </Text>
                    </Flex>
                    {/* 重點資訊 */}
                    <Flex
                      justify={{ base: "center", lg: "start" }}
                      alignItems="center"
                      mb="16px"
                      ml="8px"
                    >
                      <Flex flexDir="column" alignItems="center">
                        <Text mb="2px" textStyle="notoH16" fontWeight="700">
                          {providerFirstCar.owner_settings
                            ?.order_auto_cancel_type === "minute"
                            ? providerFirstCar.owner_settings
                                ?.order_auto_cancel_minutes /
                                60 +
                              " " +
                              t("hours")
                            : t("Station_confirm_now")}
                        </Text>
                        <Text textStyle="notoP12" color="#748598">
                          {t("Station_confirm")}
                        </Text>
                      </Flex>
                      <Box
                        w="1px"
                        h="40px"
                        bg="rgba(0, 0, 0, 0.1)"
                        mx="16px"
                      ></Box>
                      <Flex flexDir="column" alignItems="center">
                        <Text mb="2px" textStyle="notoH16" fontWeight="700">
                          {
                            providerFirstCar.owner_settings
                              ?.free_cancel_days_before
                          }{" "}
                          {t("Station_days_before")}
                        </Text>
                        <Text textStyle="notoP12" color="#748598">
                          {t("Station_cancel_free")}
                        </Text>
                      </Flex>
                      <Box
                        w="1px"
                        h="40px"
                        bg="rgba(0, 0, 0, 0.1)"
                        mx="16px"
                      ></Box>
                      <Flex flexDir="column" alignItems="center">
                        <Text mb="2px" textStyle="notoH16" fontWeight="700">
                          {t(
                            `Station_list_mileage_${
                              providerFirstCar.owner_settings?.policy
                                ?.free_mileage || "無"
                            }`
                          )}
                        </Text>
                        <Text textStyle="notoP12" color="#748598">
                          {t("Station_free_mileage")}
                        </Text>
                      </Flex>
                    </Flex>

                    {/* 多人駕駛、押金、乙式車碰車、丙式車碰車、第三人責任險 */}
                    <Wrap align="center">
                      {/* 免費多人駕駛 */}
                      {providerFirstCar?.owner_settings?.service
                        ?.multi_driver_enabled && (
                        <WrapItem>
                          <Flex mr="16px" alignItems="center">
                            <GCPImage
                              mr="4px"
                              src="/images/icons/car_green.png"
                              alt="location"
                              w="16px"
                              h="16px"
                            />
                            <Text textStyle="notoP12" color="#16B1A8">
                              {t("Station_multi_driver_enabled")}
                            </Text>
                          </Flex>
                        </WrapItem>
                      )}

                      {/* 免押金 */}
                      {providerFirstCar?.owner_settings?.policy
                        ?.deposit_amount === 0 ||
                        (providerFirstCar?.owner_settings?.policy
                          ?.deposit_amount === null && (
                          <WrapItem>
                            <Flex mr="16px" alignItems="center">
                              <GCPImage
                                mr="4px"
                                src="/images/icons/deposit.png"
                                alt="location"
                                w="16px"
                                h="16px"
                              />
                              <Text textStyle="notoP12" color="#333333">
                                {t("Station_free_deposit")}
                              </Text>
                            </Flex>
                          </WrapItem>
                        ))}
                      {/* 乙式車碰車 */}
                      {isInsurance1 && (
                        <WrapItem>
                          <Flex mr="16px" alignItems="center">
                            <GCPImage
                              mr="4px"
                              src="/images/icons/insurance.png"
                              alt="location"
                              w="16px"
                              h="16px"
                            />
                            <Text textStyle="notoP12" color="#333333">
                              {t("Station_filter_insurance_乙式-車碰車")}
                            </Text>
                          </Flex>
                        </WrapItem>
                      )}
                      {/* 丙式車碰車 */}
                      {isInsurance2 && (
                        <WrapItem>
                          <Flex mr="16px" alignItems="center">
                            <GCPImage
                              mr="4px"
                              src="/images/icons/insurance.png"
                              alt="location"
                              w="16px"
                              h="16px"
                            />
                            <Text textStyle="notoP12" color="#333333">
                              {t("Station_filter_insurance_丙式-車輛碰撞")}
                            </Text>
                          </Flex>
                        </WrapItem>
                      )}
                      {/* 第三人責任險 */}
                      {isInsurance3 && (
                        <WrapItem>
                          <Flex mr="16px" alignItems="center">
                            <GCPImage
                              mr="4px"
                              src="/images/icons/insurance.png"
                              alt="location"
                              w="16px"
                              h="16px"
                            />
                            <Text textStyle="notoP12" color="#333333">
                              {t("Station_filter_insurance_第三人責任險")}
                            </Text>
                          </Flex>
                        </WrapItem>
                      )}
                    </Wrap>
                  </Box>

                  <Flex
                    pt={{ base: "16px", lg: "0px" }}
                    flexDir="column"
                    justify="space-between"
                    w={{ base: "100%", lg: "207px" }}
                    borderLeft={{
                      base: "0px",
                      lg: "1px solid rgba(0, 0, 0, 0.1)",
                    }}
                    borderTop={{
                      base: "1px solid rgba(0, 0, 0, 0.1)",
                      lg: "0px",
                    }}
                  >
                    {/* 預留優惠資訊 */}
                    <Text></Text>

                    <Flex
                      flexDir={{ base: "row-reverse", lg: "column" }}
                      align={{ base: "center", lg: "flex-end" }}
                      justifyContent={{ base: "start", lg: "flex-end" }}
                    >
                      <Text
                        mb="2px"
                        fontSize="14px"
                        lineHeight="20px"
                        color="#748598"
                        textDecoration="line-through"
                      >
                        NT$ {providerFirstCar.origin_price.toLocaleString()}
                      </Text>
                      <Flex alignItems="">
                        <Text
                          textStyle="poppinsH20"
                          fontSize={{ base: "16px", lg: "20px" }}
                          // lineHeight={{ base: "24px", lg: "28px" }}
                          color="#333333"
                        >
                          NT$ {providerFirstCar.price.toLocaleString()}
                        </Text>

                        <Text
                          mr="4px"
                          display={{ base: "block", lg: "none" }}
                          color="#333333"
                          fontSize={{ base: "16px", lg: "20px" }}
                          // lineHeight={{ base: "24px", lg: "28px" }}
                          fontWeight="bold"
                        >
                          /
                        </Text>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              );
            })}
      </Box>
    </>
  );
};

const StationListModal = ({ isOpen, onClose, selectedCarData }) => {
  const [isOpenSort, setIsOpenSort] = useState(false);
  const [isOpenStationDetail, setIsOpenStationDetail] = useState(false);
  const isLgUp = useBreakpointValue({ base: false, lg: true });
  const [selectedLocation, setSelectedLocation] = useState(null);

  const firstCarData = useMemo(() => {
    if (!selectedCarData) return null;
    return selectedCarData[Object.keys(selectedCarData)[0]][0];
  }, [selectedCarData]);

  return (
    <>
      <StationDetailModal
        isOpen={isOpenStationDetail}
        onClose={() => setIsOpenStationDetail(false)}
        detail={selectedLocation}
      />
      <SortContentDrawer
        isOpenSort={isOpenSort && !isLgUp}
        setIsOpenSort={setIsOpenSort}
      />
      <Drawer
        isOpen={isOpen && !isLgUp}
        onClose={onClose}
        size="4xl"
        placement="bottom"
      >
        <DrawerOverlay />
        <DrawerContent borderTopRadius="16px">
          <DrawerBody p="0px" minH="95dvh" maxH="95dvh">
            <ListContent
              onClose={onClose}
              firstCarData={firstCarData}
              isOpenSort={isOpenSort}
              setIsOpenSort={setIsOpenSort}
              selectedCarData={selectedCarData}
              setSelectedLocation={setSelectedLocation}
              setIsOpenStationDetail={setIsOpenStationDetail}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Modal isOpen={isOpen && isLgUp} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent borderRadius="16px">
          <ModalBody p="0px" minH="80vh">
            <ListContent
              onClose={onClose}
              firstCarData={firstCarData}
              isOpenSort={isOpenSort}
              setIsOpenSort={setIsOpenSort}
              selectedCarData={selectedCarData}
              setSelectedLocation={setSelectedLocation}
              setIsOpenStationDetail={setIsOpenStationDetail}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default StationListModal;
